import { Component, ViewChild } from '@angular/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
declare var $: any;

@Component({
  selector: 'ppa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Participa';

  @ViewChild(ToastContainerDirective, { static: true }) toastContainer: ToastContainerDirective;

  public constructor(public toastr: ToastrService) {
  }

  ngOnInit() {
    this.toastr.overlayContainer = this.toastContainer;
  }

  ngAfterViewInit(){
      $("html, body").easeScroll();  
  }
}
